export const DEFAULT_INTERVAL_MS = 3000;

export const props = Object.freeze({
  /**
   * URL of the job status endpoint. Polled with the job ids as `ids[]` query params; answers a JSON
   * array of `{ id, status, duration }` objects whose status is one of "queued", "in_progress",
   * "past_due", "completed", or "failed".
   *
   * @type {String}
   */
  statusUrl: {
    type: String,
    required: true,
  },
  /**
   * JSON array of the job ids to track, e.g. `[12, 13]`. An array set as a property is accepted
   * as-is. Nothing renders, and nothing is polled, when the array is empty.
   *
   * @type {String|Array}
   */
  jobIds: {
    type: [String, Array],
    required: true,
  },
  /**
   * Milliseconds between polls. Polling stops once every job is completed or failed.
   *
   * @type {Number|String}
   * @default 3000
   * @storybook-control number
   */
  interval: {
    type: [Number, String],
    default: DEFAULT_INTERVAL_MS,
  },
});
